import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { PaginationQueryParamsSchema } from '@terra/shared-dto-types';
import { MongoObjectIdSchema } from '@terra/shared-utils';
import { z } from 'zod';
import { ApplicationsIdSchema } from '../applications.schema';
import {
  DirectoryScanListResponseSchema,
  DirectoryScanResponseSchema,
  StartDirectoryScanBodySchema,
  StartDirectoryScanResponseSchema,
} from './directory-scan.schema';

export const DirectoryScanContractRoutes = {
  startDirectoryScan: terraContract
    .meta({
      permissions: [PERMISSIONS.EXECUTE_TESTS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/directory-scan',
      summary: 'Start directory scan',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: StartDirectoryScanBodySchema,
      }),
    )
    .output(StartDirectoryScanResponseSchema),
  listDirectoryScans: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/{id}/directory-scan',
      summary: 'List directory scans',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        query: PaginationQueryParamsSchema,
      }),
    )
    .output(DirectoryScanListResponseSchema),
  getDirectoryScan: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/{id}/directory-scan/{scanId}',
      summary: 'Get directory scan by ID',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema.extend({
          scanId: MongoObjectIdSchema,
        }),
      }),
    )
    .output(DirectoryScanResponseSchema),
};
